import { InfoWindowItem } from './InfoWindowItem';
export class InfoWindowDescriptionItem extends InfoWindowItem {
    constructor() {
        super(...arguments);
        this.NumberValue = null; // exact value before formatting (By now, it's implemented only for InfoWindowItemType.Change)
        this.Font = null;
        this.Allowed = true;
        this.curLabelLabelWidth = 0;
        this.curValueWidth = 0;
    }
    get Label() {
        return this.label;
    }
    set Label(value) {
        this.label = value;
    }
    get Value() {
        return this.formattedValues[0];
    }
    set Value(value) {
        this.formattedValues = [value];
    }
    get Visible() {
        return this.isVisible;
    }
    set Visible(value) {
        this.isVisible = value;
    }
    get LabelWidth() {
        return this.curLabelLabelWidth;
    }
    get ValueWidth() {
        return this.curValueWidth;
    }
    SetValueWidth(newValueWidth, forceReset) {
        forceReset = forceReset || false;
        let w = Math.max(newValueWidth, 10); // min is 10 px
        w = Math.min(w, 300); // max is 300
        if (this.curValueWidth < w || forceReset) {
            this.curValueWidth = w;
        }
        return this.curValueWidth;
    }
    SetLabelWidth(newLabelWidth, forceReset) {
        forceReset = forceReset || true;
        let w = Math.max(newLabelWidth, 10); // min is 10 px
        w = Math.min(w, 300); // max is 300
        if (this.curLabelLabelWidth < w || forceReset) {
            this.curLabelLabelWidth = w;
        }
        return this.curLabelLabelWidth;
    }
}
